import { useEffect as p, useState as h, useContext as w, useCallback as y } from "react";
import { TrackingContext as v, trackEvent as L } from "./core-analytics/dist/index.js";
import x from "./help-text/help-text.module.css.js";
import g from "./validation-message/validation-message.module.css.js";
import { version as E, name as T } from "./builders-components/package.json.js";
/* empty css                                */
/* empty css          */
const A = {
  no: "Åpner i nytt vindu",
  da: "Åbner i nyt vindue",
  se: "Öppnas i nytt fönster",
  en: "Opens in new window"
};
function C(t, e) {
  p(() => {
    var i;
    const n = t.current, o = e && ((i = n == null ? void 0 : n.closest("[lang]")) == null ? void 0 : i.getAttribute("lang")), s = A[o];
    return s ? n == null || n.setAttribute("aria-description", s) : e && console.warn(`Invalid page language "${o}"`), () => n == null ? void 0 : n.removeAttribute("aria-description");
  }, [t, e]);
}
function H() {
  const [t, e] = h(() => {
  });
  return p(() => {
    e(`:b${window.buildersUUID = (window.buildersUUID || 0) + 1}`);
  }, []), t;
}
function R(t) {
  p(() => {
    const e = setTimeout(() => {
      if (t.current instanceof HTMLElement) {
        const n = t.current;
        n.hasAttribute("aria-label") || // aria-label is a valid alternative to <label>
        n.closest("label") || n.id && document.querySelector(`label[for="${n.id}"]`) || console.warn(
          "Form element missing <Label>. Please set an id={exampleId} and corresponding <Label htmlFor={exampleId}>:",
          n
        );
      }
    }, 300);
    return () => clearTimeout(e);
  }, [t]);
}
function q(t) {
  const { options: e } = w(v);
  return y(
    (n, o = {}) => {
      t && L(
        {
          eventVersion: E,
          eventSource: T,
          eventLabel: "",
          ...n,
          ...t === !0 ? {} : t,
          ...o
        },
        e
      );
    },
    [t, e]
  );
}
const U = (t) => t && typeof t == "object" && "children" in t ? t : { children: t }, W = (t, e, n) => new Promise((o) => {
  var c;
  const s = !Element.prototype.animate;
  if (((c = window.matchMedia) == null ? void 0 : c.call(
    window,
    "(prefers-reduced-motion: reduce)"
  ).matches) || s) return o(t);
  t.removeAttribute("hidden");
  const { scrollWidth: d, scrollHeight: u } = t, l = { duration: 400, easing: "ease-in-out" }, r = {
    height: [e ? `${u}px` : "0px", e ? "0px" : `${u}px`],
    paddingBlock: [e ? "" : "0px", e ? "0px" : ""],
    width: [`${d}px`, `${d}px`]
    // Set width in case table cell
  };
  t.style.overflow = "clip", n && (t.style.position = "absolute"), n && n.animate(r, l), t.animate(r, l).onfinish = () => {
    e ? t.setAttribute("hidden", "") : t.removeAttribute("hidden"), t.style.overflow = t.style.position = "", o(t);
  };
});
function f(t) {
  return t instanceof HTMLElement ? (t.innerText || t.textContent || t.getAttribute("aria-label") || "").replace(/\n/g, " ").trim() : "";
}
function N(t) {
  if (t instanceof Element && "labels" in t && (t = t.labels[0]), !(t instanceof HTMLLabelElement || t instanceof HTMLLegendElement))
    return "";
  const e = f(t.querySelector(x.helpText)), n = f(t.querySelector(g.message));
  return f(t).replace(e, "").replace(n, "");
}
function O(t) {
  if (t.key === " " || t.key === "Enter") {
    const e = new MouseEvent("click", { bubbles: !0, cancelable: !0 });
    t.preventDefault(), t.currentTarget.dispatchEvent(e);
  }
}
const B = (t, e, n = () => {
}, o = "last") => p(() => {
  let s = [];
  const i = t.current, d = [], u = (r) => ((r == null ? void 0 : r.getAttribute("aria-describedby")) || "").split(" ").filter(Boolean), l = setTimeout(() => {
    e && (s = [...document.querySelectorAll(e)]), i && s.forEach((r) => {
      const c = u(r);
      c[o === "first" ? "unshift" : "push"](i.id);
      const a = Array.from(new Set(c));
      r.setAttribute("aria-describedby", a.join(" ").trim()), d.push(n(r));
    }), (i == null ? void 0 : i.tagName) !== "LABEL" && (i != null && i.closest("label")) && console.warn(
      i,
      'is placed inside a <label>. Please move it out and use the htmlFor="ID-of-input-here" instead to enhance accessibility.'
    );
  }, 300);
  return () => {
    clearTimeout(l), s.forEach((r, c) => {
      var m;
      const a = u(r).filter((b) => b !== (i == null ? void 0 : i.id));
      r.setAttribute("aria-describedby", a.join(" ").trim()), (m = d[c]) == null || m.call(d, r);
    });
  };
}, [o, t, e, n]);
function j(t, e, n = "left") {
  const o = () => {
    e.style.top = e.style.left = "0px";
    const { left: s, width: i, bottom: d } = t.getClientRects()[0], u = e.clientWidth, l = document.documentElement.scrollWidth > window.innerWidth;
    let r;
    n === "left" || n === "start" ? r = s : n === "center" ? r = s - (u - i) / 2 : r = s + i - u;
    const c = Math.min(
      Math.max(l ? -1 / 0 : 10, r),
      l ? 1 / 0 : window.innerWidth - u - 10
    ), a = e.parentElement, m = (a == null ? void 0 : a.nodeName) === "DIALOG" && (a == null ? void 0 : a.scrollTop) || 0, b = Math.round(s + i / 2 - c);
    e.style.left = `${Math.round(c)}px`, e.style.top = `${Math.round(d) + m}px`, e.style.setProperty("--anchor-center", `${b}px`);
  };
  return document.fonts.ready.then(o), document.addEventListener("DOMContentReady", o), window.addEventListener("scroll", o, !0), window.addEventListener("resize", o), window.addEventListener("load", o), () => {
    document.removeEventListener("DOMContentReady", o), window.removeEventListener("scroll", o, !0), window.removeEventListener("resize", o), window.removeEventListener("load", o);
  };
}
export {
  j as anchorPosition,
  W as animateHidden,
  N as getLabel,
  f as getText,
  O as onRoleButtonKeyDown,
  U as toReactProps,
  B as useDescribedby,
  C as useExternalLinkText,
  H as useId,
  R as useReqireLabel,
  q as useTracking
};
//# sourceMappingURL=utils.js.map
